import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Menu from '../components/menu';
import Footer from '../components/footer';

export default function Realizations() {
    const navigate = useNavigate();
    const [realizations, setRealizations] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // Stan paginacji
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 9;

    useEffect(() => {
        const fetchRealizations = async () => {
            try {
                // Używamy adresu IP lub domeny skonfigurowanej w Apache
                const response = await axios.get('https://megamont.pl/api/realizations');
                setRealizations(response.data);
                setLoading(false);
            } catch (error) {
                console.error("Błąd podczas pobierania realizacji:", error);
                setLoading(false);
            }
        };
        fetchRealizations();
    }, []);

    // --- LOGIKA PAGINACJI ---
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = realizations.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(realizations.length / itemsPerPage);

    // Obliczanie zakresu stron (max 5 widocznych)
    let startPage, endPage;
    if (totalPages <= 5) {
        startPage = 1;
        endPage = totalPages;
    } else {
        if (currentPage <= 3) {
            startPage = 1;
            endPage = 5;
        } else if (currentPage + 2 >= totalPages) {
            startPage = totalPages - 4;
            endPage = totalPages;
        } else {
            startPage = currentPage - 2;
            endPage = currentPage + 2;
        }
    }
    const paginationRange = Array.from({ length: (endPage + 1) - startPage }, (_, i) => startPage + i);

    const handlePageChange = (pageNumber, e) => {
        if (e) e.preventDefault();
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0); 
    };

    if (loading) return null;

    return (
        <main className='MainPage'>
            <Menu active={3} />
            <section className="Realizations">
                <div className="content container">
                    <h1>Realizacje</h1>
                    <p className='shortText'>
                        Przedstawiamy wybrane projekty konstrukcji stalowych, które zrealizowaliśmy dla naszych klientów. 
                        Każdy projekt to dowód naszego doświadczenia i profesjonalizmu.
                    </p>
                    
                    <div className="row w-100">
                        {currentItems.map((real) => {
                            let images = [];
                            try {
                                images = typeof real.images === 'string' ? JSON.parse(real.images) : real.images;
                            } catch (e) {
                                images = [];
                            }
                            
                            // Ścieżka do zdjęć uwzględniająca strukturę folderów realizacja_ID
                            const firstImg = images.length > 0 
                                ? `https://megamont.pl/uploads/realizacja_${real.id}/${images[0]}` 
                                : "https://placehold.co/600x400?text=Brak+zdjęcia";

                            return (
                                <div className="col-xl-4 mb-4" key={real.id}>
                                    <div className="card shadow-sm" style={{ width: '100%', maxWidth: '28rem', margin: '0 auto' }}>
                                        <img 
                                            src={firstImg} 
                                            className="card-img-top" 
                                            alt={real.name} 
                                            style={{ height: '250px', objectFit: 'cover' }}
                                            onError={(e) => { e.target.src = "https://placehold.co/600x400?text=Błąd+ładowania"; }}
                                        />
                                        <div className="card-body">
                                            <h5 className="card-title">{real.name}</h5>
                                            <p className="card-text">
                                                {real.description?.substring(0, 120)}...
                                            </p>
                                            <div className="info d-flex justify-content-between align-items-center">
                                                <div className="d-flex gap-3">
                                                    <div className="Location d-flex align-items-center">
                                                        <i className="fas fa-map-pin me-1"></i>
                                                        <span>{real.location || "Polska"}</span>
                                                    </div>
                                                    <div className="Date d-flex align-items-center">
                                                        <i className="fas fa-calendar-alt me-1"></i>
                                                        <span>{real.start_at ? new Date(real.start_at).getFullYear() : "2025"}</span>
                                                    </div>
                                                </div>
                                                <button 
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => navigate(`/realization/${real.id}`)}
                                                >
                                                    Zobacz
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* DYNAMICZNA PAGINACJA (MAX 5) */}
                    {totalPages > 1 && (
                        <nav className='RealizationPagination mt-5'>
                            <ul className="pagination justify-content-center">
                                {/* Strzałka w lewo */}
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button 
                                        className="page-link" 
                                        onClick={(e) => handlePageChange(currentPage - 1, e)}
                                        disabled={currentPage === 1}
                                    >
                                        &laquo;
                                    </button>
                                </li>

                                {/* Pierwsza strona jeśli schowana */}
                                {startPage > 1 && (
                                    <>
                                        <li className="page-item">
                                            <button className="page-link" onClick={(e) => handlePageChange(1, e)}>1</button>
                                        </li>
                                        {startPage > 2 && <li className="page-item disabled"><span className="page-link">...</span></li>}
                                    </>
                                )}

                                {/* Numery stron (zakres paginationRange) */}
                                {paginationRange.map((pageNumber) => (
                                    <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                                        <button 
                                            className="page-link" 
                                            onClick={(e) => handlePageChange(pageNumber, e)}
                                        >
                                            {pageNumber}
                                        </button>
                                    </li>
                                ))}

                                {/* Ostatnia strona jeśli schowana */}
                                {endPage < totalPages && (
                                    <>
                                        {endPage < totalPages - 1 && <li className="page-item disabled"><span className="page-link">...</span></li>}
                                        <li className="page-item">
                                            <button className="page-link" onClick={(e) => handlePageChange(totalPages, e)}>{totalPages}</button>
                                        </li>
                                    </>
                                )}

                                {/* Strzałka w prawo */}
                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <button 
                                        className="page-link" 
                                        onClick={(e) => handlePageChange(currentPage + 1, e)}
                                        disabled={currentPage === totalPages}
                                    >
                                        &raquo;
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    )}
                </div>
            </section>
            <Footer />
        </main>
    );
}